import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const EditComponent = (props: any) => {
    const [form] = Form.useForm();
    const { defaultService } = props;
    const ref = useRef<any>(undefined);
    const [giftCardPlansData, setGiftCardPlansData] = useState<any>();
    const [giftCardStatusData, setGiftCardStatusData] = useState<any>();
    const [paymentStatusData, setPaymentStatusData] = useState<any>();
    const [platformData, setPlatformData] = useState<any>();
    const [merchantData, setMerchantData] = useState<any>();
    const [merchantOrderTypeData, setMerchantOrderTypeData] = useState<any>();
    const [shopData, setShopData] = useState<any>();
    const [giftCardTransferStatusData, setGiftCardTransferStatusData] = useState<any>();
    const [giftCardSourceData, setGiftCardSourceData] = useState<any>();
    const [giftCardDeductionTypeData, setGiftCardDeductionTypeData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'giftCardPlans',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setGiftCardPlansData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'giftCardStatus@paymentStatus@platform@giftCardTransferStatus@giftCardSource@giftCardDeductionType',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { giftCardStatus, paymentStatus, platform,
                        giftCardTransferStatus, giftCardSource, giftCardDeductionType } = res.data;
                    setGiftCardStatusData(giftCardStatus);
                    setPaymentStatusData(paymentStatus);
                    setPlatformData(platform);
                    setGiftCardTransferStatusData(giftCardTransferStatus);
                    setGiftCardSourceData(giftCardSource);
                    setGiftCardDeductionTypeData(giftCardDeductionType);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'merchant',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMerchantData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'merchantOrderType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMerchantOrderTypeData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'shop',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setShopData(res.data);
                }
            })
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        apiId: 'giftCard',
        serviceId: 'business',
        displayOptions: {
            width: 900
        },
        dateOptions: {
            columnNames: ['startDate', 'endDate', 'paymentDate', 'usageDate',
                'refundDate', 'transferDate', 'receivedDate', 'returnedDate']
        },
        formOptions: {
            instance: form,
            children: (<Row gutter={[8, 0]}>
                <Col span={4}>
                    <Form.Item
                        label="ID"
                        name="id">
                        <Input disabled={true} />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="方案"
                        name="giftCardPlansId"
                        rules={[{ required: true, message: '请选择方案!' }]}>
                        <Select
                            showSearch
                            placeholder="方案"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(giftCardPlansData, { itemName: 'planName' })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="面值"
                        name="faceValue"
                        tooltip='礼品卡面值（元）'>
                        <InputNumber
                            disabled={true}
                            style={{ width: 210 }} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="开始日期"
                        name="startDate"
                        tooltip='使用礼品卡的开始日期'>
                        <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="结束日期"
                        name="endDate"
                        tooltip='使用礼品卡的结束日期'>
                        <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="购卡金额"
                        name="purchasePrice"
                        tooltip='礼品卡购入价（元）'
                        rules={[{ required: true, message: '请输入礼品卡购入价!' }]}>
                        <InputNumber style={{ width: 160 }} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="礼品卡状态"
                        name="giftCardStatusId">
                        <Select
                            showSearch
                            placeholder="礼品卡状态"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(giftCardStatusData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="使用日期"
                        name="usageDate"
                        tooltip='礼品卡的使用日期'>
                        <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="购卡积分"
                        name="purchasePoints"
                        tooltip='礼品卡购入所需积分'
                        rules={[{ required: true, message: '请输入礼品卡购入所需积分!' }]}>
                        <InputNumber style={{ width: 160 }} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="退款日期"
                        name="refundDate"
                        tooltip='礼品卡的退款日期'>
                        <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="支付状态"
                        name="paymentStatusId">
                        <Select
                            showSearch
                            placeholder="支付状态"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(paymentStatusData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="支付日期"
                        name="paymentDate"
                        tooltip='礼品卡的支付日期'>
                        <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                    </Form.Item>
                </Col>

                <Col span={9}>
                    <Form.Item
                        label="关键id"
                        name="keyId"
                        tooltip='关键id，例如：unionId'
                        rules={[{ required: true, message: '请绑定关键id，例如：unionId!' }]}>
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="平台"
                        name="platformId"
                        rules={[{ required: true, message: '请选择平台!' }]}>
                        <Select
                            showSearch
                            placeholder="平台"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(platformData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="核销码"
                        name="redemptionCode"
                        rules={[{ required: true, message: '请输入核销码' }]}>
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={3}>
                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="关联id"
                        name="associationId">
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={5}>
                    <Form.Item
                        label="来源"
                        name="giftCardSourceId">
                        <Select
                            showSearch
                            placeholder="来源"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(giftCardSourceData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={5}>
                    <Form.Item
                        label="扣款"
                        name="giftCardDeductionTypeId">
                        <Select
                            showSearch
                            placeholder="扣款"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(giftCardDeductionTypeData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="原卡号"
                        name="parentId">
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="转赠"
                        name="transferStatusId">
                        <Select
                            showSearch
                            placeholder="转赠"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(giftCardTransferStatusData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={7}>
                    <Form.Item
                        label="转赠日期"
                        name="transferDate">
                        <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                    </Form.Item>
                </Col>

                <Col span={7}>
                    <Form.Item
                        label="受赠日期"
                        name="receivedDate">
                        <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="退回日期"
                        name="returnedDate">
                        <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item
                        label="备注"
                        name="remarks">
                        < Input.TextArea autoSize={{ minRows: 2, maxRows: 10 }} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="销售商户"
                        name="sellMerchantId"
                        tooltip='在这个商户核购买品卡'>
                        <Select
                            showSearch
                            placeholder="商户"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(merchantData, { itemName: 'merchantName', includeNull: true })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="销售店铺"
                        name="sellShopId"
                        tooltip='在这个店铺核购买品卡'>
                        <Select
                            showSearch
                            placeholder="店铺"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(shopData, { itemName: 'shopName', includeNull: true })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="支付单"
                        name="payOrderId">
                        <Input disabled={true} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="核销商户"
                        name="usageMerchantId"
                        tooltip='在这个商户核销礼品卡'>
                        <Select
                            showSearch
                            placeholder="商户"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(merchantData, { itemName: 'merchantName', includeNull: true })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="核销店铺"
                        name="usageShopId"
                        tooltip='在这个店铺核销礼品卡'>
                        <Select
                            showSearch
                            placeholder="店铺"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(shopData, { itemName: 'shopName', includeNull: true })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="单类型"
                        name="usageMerchantOrderTypeId"
                        tooltip='礼品卡核销商户单类型'>
                        <Select
                            showSearch
                            placeholder="单类型"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(merchantOrderTypeData, { itemName: 'orderTypeName' })}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={16}>
                    <Form.Item
                        label="核销商户单"
                        name="usageMerchantOrderId"
                        tooltip='礼品卡核销商户单号'>
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="核销人id"
                        name="usageId">
                        <Input />
                    </Form.Item>
                </Col>
            </Row>)
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;